/**
 * @module ConstructorIO/helpers
 */

/**
 * @param {string} value - value to decode
 * @returns {string} decoded value
 */
export const decodeValue = value => {
    let processedValue = value;
    if (typeof processedValue === 'string') {
        processedValue = processedValue.split(',');
    }
    return processedValue
        .map(v => {
            let decodedValue;
            try {
                decodedValue = decodeURIComponent(v);
            } catch (e) {
                decodedValue = v;
            }
            return JSON.stringify(decodedValue);
        })
        .join(',');
};

/**
 *
 * @param {Array} variationsMap - variations_map
 * @param {import('../product').default} product - Constructor product to get the URL of
 * @param {string} countryPath - the URL country path which can be used for URL building.
 * @returns {string} product URL
 */
export const getProductURL = (variationsMap, product, countryPath) => {
    const variationsLength = variationsMap ? variationsMap.length : 0;
    const additionalInfo = product.get('additionalInfo');
    const isSet = !!additionalInfo?.isSet;
    return `${countryPath}${
        (variationsLength === 1 || isSet) && product.get('url') ? product.get('url') : product.get('parentURL')
    }`;
};
